// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"PageContent_pageContent__2scjm"};